import { render, staticRenderFns } from "./managedInstructionAssignmentAssignedDialogEmail.vue?vue&type=template&id=5e3bc34d"
import script from "./managedInstructionAssignmentAssignedDialogEmail.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentAssignedDialogEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports